module.exports = __webpack_public_path__ + "img/144.053da2f1.jpg";